import { render, staticRenderFns } from "./IMPDF.vue?vue&type=template&id=48891014"
import script from "./IMPDF.vue?vue&type=script&lang=js"
export * from "./IMPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports